import React from "react";
import { Tabs } from "antd";
import { FONT } from "constants/index";

import ReviewsClientAquaKids from "./reviews-client-aqua-kids";
import ReviewsClientAqua from "./reviews-client-aqua";

const ReviewsAquaTab = () => {
  const items = [
    {
      label: `Adulto`,
      key: "boot",
      children: <ReviewsClientAqua />,
    },
    {
      label: `Kids`,
      key: "metodo",
      children: <ReviewsClientAquaKids />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      centered
      size="large"
      style={{ fontFamily: FONT }}
      items={items}
    />
  );
};
export default ReviewsAquaTab;
